import React from "react";
import * as CHQ from "chq";

import { EventLink, ProfileLink } from "app/links";
import { t, Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

export const rsvpTypes = {
  accepted: t("Yes"),
  checked_in: t("Checked In"),
  declined: t("No"),
  interested: t("Interested")
};

type EventHostingRsvpdNotificationProps = {
  notification: CHQ.NotificationEventHostingRsvpd;
  tabIndex?: number;
};

const EventHostingRsvpdNotification: React.FC<EventHostingRsvpdNotificationProps> = ({
  notification: { actor, message, entity }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <Trans>
      <ProfileLink user={actor} tabIndex={tabIndex || 0} /> RSVP&#39;d
      {" "}
      {message && <>&quot;{rsvpTypes[message]}&quot;{" "}</>}
      to your event:
    </Trans>
    {" "}
    { entity && (<EventLink event={entity.event} tabIndex={tabIndex || 0} />) }
  </NotificationBody>
);

export default EventHostingRsvpdNotification;
